import React from 'react'
import PropTypes from 'prop-types'
import { makeHamburger } from './styled'

export const RawHamburger = makeHamburger('div')

function Hamburger(props) {
  return (
    <RawHamburger id='hamburger' className={props.open ? 'open' : null} {...props}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </RawHamburger>
  )
}

Hamburger.propTypes = {
  open: PropTypes.bool,
}

export default Hamburger
